export default __webpack_public_path__ + "static/media/publish.c0e7b094.svg";